import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { showPopup } from 'swag-client-common/redux/popup-manager/popup-manager.actions';
import { EDIT_BOX_NOTECARD_POPUP } from 'swag-client-common/constants';
import { isEditBoxNotecardPreventClosePopupSelector } from 'swag-client-common/redux/popup-manager/popup-manager.selector';
import { closeBoxNotecardEditorPopup } from '../../../redux/box-notecard-editor/box-notecard-editor.actions';
import { NotecardPreventClosePopup } from './notecard-prevent-close-popup';
const mapStateToProps = createStructuredSelector({
  open: isEditBoxNotecardPreventClosePopupSelector
});
const mapDispatchToProps = dispatch => ({
  handleConfirm: () => {
    dispatch(closeBoxNotecardEditorPopup());
  },
  handleCancel: () => {
    dispatch(showPopup({
      popup: EDIT_BOX_NOTECARD_POPUP
    }));
  }
});
export const BoxNotecardPreventClosePopup = connect(mapStateToProps, mapDispatchToProps)(NotecardPreventClosePopup);